<template>
    <td>
        <ul style="list-style:circle;">
            <li v-for="product in results">{{ product.brandName || '' }}, {{ product.collectionName || ''}}, {{ product.name || '' }}</li>
        </ul>
    </td>
</template>

<script>
import * as algoliasearch from 'algoliasearch'

const client = algoliasearch(process.env.ALGOLIA_APP_ID, process.env.ALGOLIA_SEARCH_KEY);
const productIndex = client.initIndex(process.env.ENV_SHORTNAME + '_products')

export default {
    props: ['data'],
    data () {
        return {
            results: [],
            originData: null
        }
    },
    watch: {
        data () {
            this.results = []
            this.dataHandler()
        }
    },
    methods: {
        searchProductById(id, multiData) {
            var my = this
            productIndex.search({
                distinct: true,
                query: id,
                hitsPerPage: 1,
                attributesToRetrieve: [
                    'name',
                    'brandName',
                    'collectionName'
                ]
            },
            function searchDone (err, content) {
                if (err) throw err
                if (content.hits[0]) {
                    multiData ? my.results.push(content.hits[0]) : my.results = [content.hits[0]]
                }
            })
        },
        dataHandler () {
            if (this.data && typeof this.data === 'string') {
                this.searchProductById(this.data)
            } else {
                this.data.forEach(value => {
                    this.searchProductById(value, 'multiData')
                })
            }
            this.$forceUpdate()
        }
    },
    mounted () {
        this.dataHandler()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/CRUDs/ProductRow.vue